import { KeyboardArrowRight, Menu, Print } from '@mui/icons-material';
import { AppBar, IconButton, Popover, Toolbar, Tooltip } from '@mui/material';
import { action, computed, observable, reaction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import './css/util.css';
import MenuPrincipalPopper from './misc/MenuPrincipalPopper';
import TopBarAction from './misc/TopBarAction';
import ConsultaProcesso from './components/ConsultaProcesso';
import ParametroStore from './store/ParametroStore';
import RouterStore from './store/RouterStore';
import TopBarStore from './store/TopBarStore';
import Ambiente from './utils/Ambiente';
import UsuarioStore from './store/UsuarioStore';
import ModalProcessosAssociadosEspelho from './components/ModalProcessosAssociadosEspelho';

const BotaoImportar = React.lazy(() => import('./components/controle-gabinete/BotaoImportar'));

const styles = {
    title: {
        cursor: 'pointer'
    }
};

interface TopBarProps {}


class TopBar extends React.PureComponent<TopBarProps> {
    displayAppBar = true;
    appNome = Ambiente.appNome;

    reactionTrocaRota = reaction(() => RouterStore.lastRoute, _rota => {
        this.identificaNome();
    });

    identificaNome = () => {
        if (!RouterStore.isAM) {
            this.appNome = Ambiente.appNome;
        } else {
            this.appNome = 'Hermes';
        }
    };

    constructor(props: TopBarProps) {
        super(props);

        makeObservable(this, {
            displayAppBar: observable,
            appNome: observable,
            identificaNome: action,
            mostrarTituloTela: computed,
            podeImportarProcessoEspelho: computed
        });
    }

    get mostrarTituloTela() {
        if (RouterStore.isRotaEspelho) {
            return (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={styles.title} onClick={this.recarregarTelaPrincipal}>
                        {Ambiente.appNome}
                    </span>
                    <KeyboardArrowRight style={{ color: 'white' }} />
                    Espelho do Processo
                </span>
            );
        }

        let topBarTitle;
        if (TopBarStore.titulo !== null && TopBarStore.titulo !== '') {
            topBarTitle = (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    {!RouterStore.isAM ? (
                        <span style={styles.title} onClick={this.irParaTelaPrincipal}>
                            {this.appNome}
                        </span>
                    ) : (
                        <span style={styles.title} onClick={this.irParaTelaPrincipalAM}>
                            {this.appNome}
                        </span>
                    )}
                    <KeyboardArrowRight style={{ color: 'white' }} /> {TopBarStore.titulo}
                </span>
            );
        } else {
            topBarTitle = (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    {!RouterStore.isAM ? (
                        <span style={styles.title} onClick={this.irParaTelaPrincipal}>
                            {this.appNome}
                        </span>
                    ) : (
                        <span style={styles.title} onClick={this.irParaTelaPrincipalAM}>
                            {this.appNome}
                        </span>
                    )}
                </span>
            );
        }
        return topBarTitle;
    }

    irParaTelaPrincipal = () => {
        RouterStore.push('/telaPrincipal');
    }

    recarregarTelaPrincipal = () => {
        RouterStore.redirecionamentoExterno('/telaPrincipal');
    }

    irParaTelaPrincipalAM = () => {
        RouterStore.push('/assistenteMinutas');
    }

    imprimirEspelho = () => {
        RouterStore.abrirJanela('/impressaoEspelhoProcesso/' + RouterStore.params.idProcesso);
    }

    get podeImportarProcessoEspelho() {
        return RouterStore.processoImportacaoEspelho
            && RouterStore.dadosProcessoEspelho?.orgaoJulgador?.sigla === UsuarioStore.localizacao?.siglaOrgaoJulgador;
    }

    state = {
        anchorEl: null,
        exibirTooltipMenu: true,
    }

    toggleMenu = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ exibirTooltipMenu: false });
        TopBarStore.toggleMenu(event);
    }

    habilitarTooltipMenu = () => {
        this.setState({ exibirTooltipMenu: true });
    }

    handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    handlePopoverClose = () => {
        this.setState({ anchorEl: null });
    }

    toggleModoCompacto = () => {
        ParametroStore.toggleVisualizacaoCompacta();
        this.handlePopoverClose();
    }

    render() {
        return (
            <div id='app-bar' style={{ fontSize: '24px', display: TopBarStore.mostrar ? 'flex' : 'none', minHeight: '60px' }}>
                <AppBar color='primary' className='esconderImpressao' style={{ top: 0, left: 0 }} position='relative'>
                    <Toolbar color='primary' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className='aCenter' style={{ display: 'flex', color: 'white' }}>
                            {!RouterStore.isRotaEspelho &&
                                <Tooltip
                                    title={!TopBarStore.menuAberto && this.state.exibirTooltipMenu ? 'Menu completo' : ''}
                                    disableFocusListener
                                    disableInteractive
                                >
                                    <div
                                        style={{ color: 'white', paddingRight: 25, paddingLeft: 7 }}
                                        onMouseLeave={this.habilitarTooltipMenu}
                                    >
                                        <IconButton edge='start' color='inherit' onClick={this.toggleMenu} aria-label='Menu Completo do Gabinete Eletrônico'>
                                            <Menu />
                                        </IconButton>
                                        <Popover
                                            open={TopBarStore.menuAberto}
                                            onClose={TopBarStore.fechaMenu}
                                            anchorEl={TopBarStore.anchorEl}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            sx={{ marginLeft: '-15px', marginTop: '15px' }}>
                                            <MenuPrincipalPopper />
                                        </Popover>
                                    </div>
                                </Tooltip>
                            }
                            <Tooltip title='Menu principal'>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {this.mostrarTituloTela}
                                </div>
                            </Tooltip>
                        </div>
                        {RouterStore.isEspelho ?
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {this.podeImportarProcessoEspelho &&
                                    <React.Suspense fallback={null}>
                                        <BotaoImportar
                                            processosParaImportar={[RouterStore.processoImportacaoEspelho]}
                                            forcarImportar={true}
                                            origemImportacaoGE='Espelho do Processo'
                                            modoIcone
                                        />
                                    </React.Suspense>
                                }
                                <ModalProcessosAssociadosEspelho
                                    processosAssociados={RouterStore.dadosProcessoEspelho?.processosAssociados || []}
                                    correJuntos={RouterStore.dadosProcessoEspelho?.correJuntos || []}
                                />
                                <ConsultaProcesso consultarViaAbaGe />
                                <Tooltip title={RouterStore.erroCarregamentoEspelho
                                    ? 'Impressão indisponível'
                                    : 'Imprimir espelho do processo'
                                }>
                                    <span>
                                        <IconButton
                                            color='inherit'
                                            onClick={this.imprimirEspelho}
                                            aria-label='Imprimir espelho do processo'
                                            disabled={RouterStore.erroCarregamentoEspelho}
                                        >
                                            <Print />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </div>
                            :
                            !RouterStore.isRotaEspelho && <TopBarAction />
                        }
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default observer(TopBar);
